import { render, staticRenderFns } from "./StaffRowHeader.vue?vue&type=template&id=2c119c9d&"
import script from "./StaffRowHeader.vue?vue&type=script&lang=js&"
export * from "./StaffRowHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports